import React, { useEffect, useState } from 'react';

// material-ui
import {
    CardContent,
    Grid,
    IconButton,
    Card,
    TextField,
} from '@mui/material';
import axios from 'axios';
import moment from 'moment';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import ChartHistory from './ChartHistory';

// assets
import SendTwoToneIcon from '@mui/icons-material/SendTwoTone';
import { History } from './ChartHistory';
import useAuth from 'hooks/useAuth';
import { useTranslation } from 'react-i18next';
import i18n from 'utils/i18n';
import { useSpeechRecognition } from 'react-speech-recognition';
import useSpeechSynthesis from 'hooks/useSpeechSynthesis';
// import { useDispatch } from 'store';
// import { hideTalk, showTalk } from 'store/slices/loadingCursor';
import Text from '../Data/Text';
const dataw: History[] = [
    {
        from: 'bot',
        to: 'to',
        time: moment().format('HH:mm'),
        text: i18n.t(`Hi, I'm your assistant`)
    },
    {
        from: 'bot',
        to: 'to',
        time: moment().format('HH:mm'),
        text: i18n.t("Can I help you?")
    }
]
export default function ChatMainPage() {
    const { showAlert } = useAuth();
    const { t } = useTranslation();
    const [message, setMessage] = useState('');
    const [data, setData] = useState<History[]>(dataw);
    const [isRepling, setIsRepling] = useState<boolean>(false);
    const handleEnter = (event: React.KeyboardEvent<HTMLDivElement> | undefined) => {
        if (event?.key === 'Enter' && !event?.shiftKey) {
            event?.preventDefault();
            handleOnSend();
        }
        return;
    }
    const handleOnSend = async () => {
        if (message === "") return;
        setData((prevData: any) => [
            ...prevData,
            {
                from: 'User',
                to: 'to',
                time: moment().format('HH:mm'),
                text: message
            }
        ]);
        setMessage('');
        sendMessage(message);
    }
    const gptAPI = async (message: string) => {
        const dataSend = {
            model: 'gpt-3.5-turbo-0125',
            messages: [{ role: 'user', content: message }]
        };
        const url = 'https://api.openai.com/v1/chat/completions'
        const headers = {
            'Content-type': 'application/json',
            Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`
        }

        axios.post(url, dataSend, { headers: headers }).then((response) => {
            let text: string = response.data.choices[0].message.content ?? "";
            text = text.replace(/\n/g, "<br />");
            if (text) {
                setIsRepling(false);
                setData((prevData: any) => [
                    ...prevData,
                    {
                        from: 'bot',
                        to: 'to',
                        time: moment().format('HH:mm'),
                        text: text
                    }
                ]);
            }
        });
    }
    const geminiAPI = async (message: string) => {
        const url = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent?key=AIzaSyBZzQxLge5TaJEfaMl4iEpbAMErSzQmHyA';
        const dataSend = {
            contents: [{ parts: [{ text: message }] }]
        };
        const headers = {
            'Content-Type': 'application/json',
            // Authorization: `Bearer ${process.env.REACT_APP_GEMINI_API_KEY}`
        };
        const response = await axios.post(url, dataSend, { headers });
        let text: string = response.data.candidates?.[0]?.content?.parts?.[0]?.text ?? "";
        text = text.replace(/\n/g, "<br />");

        if (text) {
            setIsRepling(false);
            setData((prevData: any) => [
                ...prevData,
                {
                    from: 'bot',
                    to: 'to',
                    time: moment().format('HH:mm'),
                    text: text
                }
            ]);
        }
    }

    const sendMessage = (message: string) => {
        setIsRepling(true);
        try {
            geminiAPI(message)
        } catch (error) {
            console.log(error);
            showAlert(t('Some Thing went wrong'), 'error');
        }
    }

    const { speak } = useSpeechSynthesis();
    const { listening, finalTranscript, transcript, resetTranscript } = useSpeechRecognition();

    useEffect(() => {
        const handleTranscript = async (text: string = "") => {
            const stringTrim = text.toLowerCase().trim();
            const res = Text.find((item) => {
                return item.keyword.find((item2) => stringTrim.includes(item2));
            });
            if (res) {
                setData((prevData: any) => [
                    ...prevData,
                    {
                        from: 'User',
                        to: 'to',
                        time: moment().format('HH:mm'),
                        text: text
                    }
                ]);
                speak({ text: res.response[0] });
                if (res.type !== "gpt") {
                    setData((prevData: any) => [
                        ...prevData,
                        {
                            from: 'bot',
                            to: 'to',
                            time: moment().format('HH:mm'),
                            text: res.response[0]
                        }
                    ]);
                }
                resetTranscript();
                if (res.func) {
                    if (res.type) {
                        setIsRepling(true);
                        const resp: any = await res.func(text);
                        if (res.type === 'gpt') {
                            // speak({ text: resp.replace("<br />", "") });
                            speak({ text: "Maybe it can help you" });
                            setData((prevData: any) => [
                                ...prevData,
                                {
                                    from: 'bot',
                                    to: 'to',
                                    time: moment().format('HH:mm'),
                                    text: resp
                                }
                            ]);
                        }
                        setIsRepling(false);
                    } else {
                        await res.func();
                    }
                }
            }
        };
        if (listening && transcript) {
            handleTranscript(transcript);
        }
    }, [transcript, finalTranscript, listening]);

    return (
        <Grid container spacing={2}>
            <Grid item xs zeroMinWidth>
                <Card
                    sx={{
                        width: { md: '100%', sm: '100%' },
                        p: 3,
                        pb: 0,
                        height: "100vh",
                    }}
                >
                    <Grid container spacing={2}>
                        <PerfectScrollbar
                            style={{ width: '100%', height: 'calc(100vh - 105px)', overflowX: 'hidden', minHeight: 400 }}
                        >
                            <CardContent sx={{ pl: 0, pr: 0 }}>
                                <ChartHistory data={data} />
                            </CardContent>
                        </PerfectScrollbar>
                        <Grid item xs={12}>
                            <Grid container spacing={1} alignItems='center'>
                                {isRepling && (
                                    <Grid item xs={12} position="relative">
                                        <div className="wrapper-chat">
                                            <div className="bubble">
                                                <div className="bubble__circle" />
                                                <div className="bubble__circle" />
                                                <div className="bubble__circle" />
                                            </div>
                                        </div>
                                    </Grid>
                                )}
                                <Grid item xs zeroMinWidth>
                                    <TextField
                                        fullWidth
                                        label={t("Type a Message")}
                                        value={message}
                                        multiline
                                        onChange={(e) => setMessage(e.target.value)}
                                        onKeyPress={handleEnter}
                                        autoComplete='off'
                                        sx={{
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: '#696969'
                                            },
                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'rgb(0 0 0 / 86%)'
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <IconButton
                                        color='primary'
                                        onClick={handleOnSend}
                                        disabled={message === '' ? true : false}
                                        size='large'
                                    >
                                        <SendTwoToneIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Card>
            </Grid>
        </Grid>
    )
}
